import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">

                                            <table className="ilead_v_sport tablesrink people_active2"
                                                   border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <td className="subheading2bg roundBorder lightBG1Dark"
                                                        align="left" valign="top" width="15%"><p><span
                                                        className="subtiltereg">2.1 Match
skills</span></p>
                                                    </td>
                                                    <td className="lightgreen roundBorder1" align="left"
                                                        valign="top" width="85%">
                                                        <ul className="greenbullet-list uiheading greenbullet-listspacing_last">
                                                            <li><p>Consider the tasks that need to be completed
                                                                and the roles that need to be
                                                                played and write down the skills that are
                                                                required for each. Consider which
                                                                individuals have the necessary skills and enjoy
                                                                using them.</p></li>
                                                        </ul>

                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td className="subheading2bg lightBG1Dark" align="left"
                                                        valign="top" width="15%"><p><span
                                                        className="subtiltereg">2.2. Match knowledge</span></p>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="middle"
                                                        width="85%">
                                                        <ul className="greenbullet-list uiheading ">
                                                            <li><p>Are there any areas of specific knowledge or
                                                                experience that are required to
                                                                complete the tasks and play the roles?</p></li>


                                                        </ul>


                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td className="subheading2bg lightBG1Dark" align="left"
                                                        valign="top" width="15%"><p><span
                                                        className="subtiltereg">2.3 Apply strengths</span></p>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="85%">
                                                        <ul className="greenbullet-list uiheading">
                                                            <li><p>Consider which tasks and roles would benefit
                                                                from the strengths of team
                                                                members that you identified at stage one.</p>
                                                            </li>
                                                            <li><p>Bear in mind that variety in a role is
                                                                important and to engage others
                                                                you’ll need to help them use more than just one
                                                                of their strengths!</p></li>
                                                            <li><p>Consider the strengths of each individual in
                                                                the team and consider how
                                                                you can bring their strengths to life in
                                                                completing the task or in the role that
                                                                you are giving them.</p></li>
                                                            <li><p>If you’re not sure about how you can best use
                                                                an individual’s strengths,
                                                                be sure to ask them.</p></li>

                                                        </ul>
                                                    </td>

                                                </tr>
                                                </tbody>
                                            </table>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>ENGAGING DIFFERENT TYPES
                                            </div>
                                            <div className="paraspace"><p>Here are examples of how to use team
                                                members’ strengths, which will help increase their desire
                                                and ability to deliver.</p></div>
                                            <div className="lightgreencontentbg keyquestionpad uiheading">
                                                <div className="border_subtitle">How to engage an achiever</div>
                                                <p style={{paddingBottom:'9px !important'}}>An ‘achiever’ is
                                                    someone who is motivated by their progress and completion of
                                                    tasks, and
                                                    tends to be very goal- and time-orientated.</p>
                                                <ul className="greenbullet-list greenbullet-listspacing">
                                                    <li>Recognise that they like to be busy and sitting in
                                                        meetings may bore them. Ask them to
                                                        attend crucial meetings only, where they’ll be more
                                                        fully engaged.
                                                    </li>
                                                    <li>Help them recognise their simpler achievements so
                                                        they’re aware of their productivity
                                                        as well as the time they contribute, such as the number
                                                        of customers served, phone
                                                        calls made, reports reviewed, etc.
                                                    </li>
                                                    <li className="textbottompadding">Reward them for achieving
                                                        difficult tasks and set further challenges immediately
                                                        rather
                                                        than giving a rest or an easy assignment.
                                                    </li>

                                                </ul>
                                            </div>

                                            <div className="lightgreencontentbg keyquestionpad uiheading">
                                                <div className="border_subtitle">How to engage someone strong in
                                                    input
                                                </div>
                                                <p style={{paddingBottom:'9px !important'}}>Someone strong in
                                                    input tends to want to influence decisions and output by
                                                    providing
                                                    information and expertise and also offering constructive
                                                    criticism. They tend to be very
                                                    analytical in their approach.</p>
                                                <ul className="greenbullet-list greenbullet-listspacing">
                                                    <li>Engage their natural inquisitiveness by asking them to
                                                        undertake associated research
                                                        for a project, before work begins on it.
                                                    </li>
                                                    <li>Give them a role in which they’ll be doing research.
                                                        Keep them informed of any news
                                                        that influences the team or project. Pass on journals,
                                                        articles and books to stimulate
                                                        their interest.
                                                    </li>
                                                    <li className="textbottompadding">Encourage them to organise
                                                        all the information they collect, so others in the team
                                                        can
                                                        benefit from it.
                                                    </li>

                                                </ul>

                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page3')}
                                                        className="button-next-previous-done task">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page5')}
                                                        className="button-next-previous-done task">Next &gt;&gt;</div>
                                                </div>
                                            </div>

                                        </div>


                                    </div>


                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}